module.exports = __webpack_public_path__ + "common/logistics/icon-flash-3d8c8d5d7559d6e187caa286ed508fa8.svg";